<template>
    <div class="cookie-policy">
        <h1>Cookies</h1>
        <p class="sub-title">Cookie Notice</p>
        <p class="update-time">Last revised: January 4, 2026</p>

        <section>
            <p>
                This Cookie Policy explains how Contrimetric (also referred to below as “we”, “us”, “our”)
                uses cookies and similar technologies on our website, in accordance with the EU General
                Data Protection Regulation (GDPR) and the ePrivacy Directive.
            </p>
            <p>
                Serving as part of the Privacy Policy for the application or website, this Cookie Notice is
                linked to the terms of use (the “Website”).
            </p>
        </section>

        <section>
            <h2>1. What Are Cookies</h2>
            <p>
                Cookies are small text files that are placed on your device (computer, tablet, or mobile)
                when you visit a website.
            </p>
            <p>
                Cookies may be session cookies (deleted when you close your browser) or persistent cookies
                (stored for a defined period or until deleted).
            </p>
        </section>

        <section>
            <h2>2. How We Use Cookies</h2>
            <ul>
                <li><strong>Essential functionality</strong> – ensure the website operates correctly</li>
                <li><strong>Performance and analytics</strong> – understand how visitors use our site</li>
                <li><strong>User preferences</strong> – remember basic settings and preferences</li>
            </ul>
            <p>
                We do not use cookies for behavioral advertising unless explicitly stated.
            </p>
        </section>

        <section>
            <h2>3. Types of Cookies We Use</h2>

            <h3>3.1 Strictly Necessary Cookies</h3>
            <p>
                These cookies are required for the basic operation of the website and cannot be disabled.
            </p>

            <h3>3.2 Analytics / Performance Cookies</h3>
            <p>
                These cookies collect aggregated and anonymized information about how visitors use our website.
            </p>

            <h3>3.3 Functional Cookies (if applicable)</h3>
            <p>
                These cookies enable enhanced functionality, such as remembering preferences.
            </p>
        </section>

        <section>
            <h2>4. Control of the Cookies</h2>
            <p>
                You can control and manage cookies through your browser settings or via the Cookie Settings link.
            </p>
            <p>
                More information:
                <a href="https://www.aboutcookies.org/" target="_blank">https://www.aboutcookies.org/</a>
            </p>
        </section>

        <section>
            <h2>5. Updates to This Cookie Policy</h2>
            <p>
                We may update this Cookie Policy from time to time. Updates will be published on this page.
            </p>
        </section>

        <section>
            <h2>6. Contact Information</h2>
            <p><strong>CONTRIMETRIC PTE. LTD.</strong></p>
            <p>Email:
                <a href="mailto:contact@contrimetric.com">contact@contrimetric.com</a>
            </p>
            <p>Address: 8 Eu Tong Sen Street, #16-81, The Central, Singapore 059818</p>
        </section>

        <div class="page_button">
            © Contrimetric Pte. Ltd. All rights reserved.
        </div>
    </div>
</template>

<script>
export default {
    name: 'CookiePolicy'
}
</script>

<style scoped>
.cookie-policy {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    font-size: 14px;
    line-height: 1.8;
    color: #333;
    font-family: 'Open Sans,sans-serif';
}

h1 {
    font-size: 32px;
    margin-bottom: 10px;
}

.sub-title {
    font-weight: 600;
    font-size: 16px;
}

.update-time {
    color: #888;
    margin-bottom: 30px;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    font-weight: bold;
    font-size: 16px;
}

section {
    margin-bottom: 28px;
}

h2 {
    margin-bottom: 10px;
    font-size: 20px;
}

h3 {
    margin-top: 10px;
    font-size: 16px;
}

ul {
    padding-left: 18px;
}

a {
    color: #1e80ff;
    word-break: break-all;
}

p {
    color: #595959;
}

.page_button {
    text-align: center;
    color: #999;
    margin-top: 40px;
    border-top: 1px solid #eee;
    padding-top: 20px;
}
</style>
